/* eslint-disable consistent-return */
import isServer from 'src/common/utils/isServer';

// Method found here:
// https://jonathanmh.com/how-to-detect-ad-blockers-adblock-ublock-etc/
// Tested with uBlock and AdBlock...
//
export default async function isAdBlockEnabled(callback) {
  if (isServer()) {
    return callback(false);
  }

  try {
    await fetch(
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
      {
        method: 'HEAD',
        mode: 'no-cors',
      },
    );

    callback(false);
  } catch (e) {
    callback(true);
  }
}
